import React, { useState } from 'react'
import { Box, Flex } from '../../../ui/Layout'
import Icon from '../../../ui/Icon'
import ModalContainer from '../../../ui/ModalContainer'
import { Text } from '../../../ui/Typography'
import Image from '../../../ui/Image'
import { Field } from 'formik'
import { Input } from '../../../ui/Input'
import formikFormWrapper from '../../../formikFormWrapper'
import { Label } from '../../../ui/Typography'
import { MODAL_OPEN_TYPES } from '../CampaignEditor'
import VideoProductModal from '../../../Videos/VideoProductModal'

const FormInput = formikFormWrapper(Input)

const ImageCarousel = ({ videos, activeIndex, setActiveIndex }) => {
  const activeVideo = videos[activeIndex]
  const nextIndex = activeIndex === videos.length - 1 ? 0 : activeIndex + 1
  const nextVideo = videos[nextIndex]
  const videoWidth = 400
  const videoHeight = Math.round(videoWidth * (9 / 16))

  const getImageUrl = (video) => {
    const isImage = video.type === 'IMAGE'

    if (isImage) {
      return `https://clipara.b-cdn.net/${video.path}?width=500`
    }

    if (video.customThumbnail) {
      if (video.customThumbnail.includes('clipara.b-cdn.net')) {
        return `${video.customThumbnail}?width=${Math.round(videoWidth)}&height=${Math.round(videoHeight)}`
      }
      return `${video.customThumbnail}-/scale_crop/${Math.round(videoWidth)}x${Math.round(videoHeight)}/center/`
    }
    return `https://image.mux.com/${video.playbackId}/thumbnail.png?time=${video.thumbnailTime || 0.0}&width=${Math.round(
      videoWidth
    )}&height=${Math.round(videoHeight)}&fit_mode=crop`
  }

  const imageUrl = getImageUrl(activeVideo)
  const nextImageUrl = getImageUrl(nextVideo)

  return (
    <Flex mb="24px">
      <Image
        src={nextImageUrl}
        alt="Preload next"
        width="1px"
        height="1px"
        position="absolute"
        opacity="0"
        pointerEvents="none"
      />

      <Flex alignItems="center" justifyContent="center">
        <Flex
          onClick={() => setActiveIndex((prev) => (prev === 0 ? videos.length - 1 : prev - 1))}
          cursor="pointer"
          borderRadius="50%"
          boxShadow="0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);"
          width="32px"
          height="32px"
          alignItems="center"
          justifyContent="center"
          userSelect="none"
        >
          <Icon transform="rotate(180deg)" icon="chevron-right-grey" width="12px" height="12px" />
        </Flex>

        <Image
          loading="lazy"
          key={activeVideo.id}
          src={imageUrl}
          alt={`Video ${activeIndex + 1}`}
          width="187px"
          height="240px"
          borderRadius="12px"
          objectFit="cover"
          mx="12px"
        />
        <Flex
          onClick={() => setActiveIndex((prev) => (prev === videos.length - 1 ? 0 : prev + 1))}
          cursor="pointer"
          borderRadius="50%"
          boxShadow="0px 0px 1px 0px rgba(12, 26, 75, 0.24), 0px 3px 8px -1px rgba(50, 50, 71, 0.05);"
          width="32px"
          height="32px"
          alignItems="center"
          justifyContent="center"
          userSelect="none"
        >
          <Icon icon="chevron-right-grey" width="12px" height="12px" />
        </Flex>
      </Flex>
    </Flex>
  )
}

const ThumbnailGrid = ({ videos, activeIndex, setActiveIndex, getImageUrl }) => {
  return (
    <Box p="24px">
      <Box display="grid" gridTemplateColumns="1fr 1fr 1fr" gap="16px">
        {videos.map((video, index) => (
          <Box key={video.id} width="calc(33.33% -2px)" m="2px" cursor="pointer" onClick={() => setActiveIndex(index)}>
            <Box
              position="relative"
              borderRadius="0px"
              overflow="hidden"
              border={activeIndex === index ? '4px solid #0066FF' : '4px solid transparent'}
            >
              <Image src={getImageUrl(video)} alt={`Thumbnail ${index + 1}`} width="100%" height="155px" objectFit="cover" />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

const TitleShoppingButtonModal = ({ selectedVideos = [], modalOpenType, setModalOpenType, values, setFieldValue }) => {
  if (!modalOpenType) return null

  const [activeIndex, setActiveIndex] = useState(0)
  const activeVideo = selectedVideos[activeIndex]
  console.log(activeVideo)

  const [showVideoToProductModal, setShowVideoToProductModal] = useState(false)

  const getImageUrl = (video) => {
    const videoWidth = 400
    const videoHeight = Math.round(videoWidth * (9 / 16))

    const isImage = video.type === 'IMAGE'

    if (isImage) {
      return `https://clipara.b-cdn.net/${video.path}?width=500`
    }

    if (video.customThumbnail) {
      if (video.customThumbnail.includes('clipara.b-cdn.net')) {
        return `${video.customThumbnail}?width=${Math.round(videoWidth)}&height=${Math.round(videoHeight)}`
      }
      return `${video.customThumbnail}-/scale_crop/${Math.round(videoWidth)}x${Math.round(videoHeight)}/center/`
    }
    return `https://image.mux.com/${video.playbackId}/thumbnail.png?time=${video.thumbnailTime || 0.0}&width=${Math.round(
      videoWidth
    )}&height=${Math.round(videoHeight)}&fit_mode=crop`
  }

  const renderFields = () => {
    if (!modalOpenType) return null

    switch (modalOpenType) {
      case MODAL_OPEN_TYPES.TITLES:
        return (
          <Flex flexDirection="column" px="24px">
            {selectedVideos.map((video, index) => (
              <Box key={video.id} display={activeIndex === index ? 'block' : 'none'}>
                <Field mb="16px" width="100%" name={`titles.${video.id}`} label="Title" dark component={FormInput} />
                <Field mb="16px" width="100%" name={`subtitles.${video.id}`} label="Subtitle" dark component={FormInput} />
              </Box>
            ))}
          </Flex>
        )
      case MODAL_OPEN_TYPES.SHOPPING:
        return (
          <Flex flexDirection="column" px="24px">
            <Label mb="16px">Shoppable Items</Label>
            {activeVideo.linkedProducts?.map((dbProduct, index) => {
              const product = dbProduct?.product
              return (
                <Flex key={index} alignItems="center" mb="16px">
                  <Flex width="60px" height="60px" minWidth="60px" minHeight="60px">
                    <Image
                      height="100%"
                      width="100%"
                      objectFit="cover"
                      borderRadius="4px"
                      src={product?.image ? product?.image.src : product?.media && product?.media[0]?.src}
                    />
                  </Flex>

                  <Flex flexDirection="column" ml="16px">
                    <Text fontWeight="600">{product.title}</Text>
                  </Flex>
                </Flex>
              )
            })}
            <Flex onClick={() => setShowVideoToProductModal(true)} cursor="pointer">
              <Flex width="auto">
                <Icon mt="6px" mr="8px" icon="plus-black" width="12px" height="12px" />
                <Text fontSize="14px" fontWeight="600">
                  Add An item
                </Text>
              </Flex>
            </Flex>
          </Flex>
        )
      case MODAL_OPEN_TYPES.BUTTONS:
        return (
          <Flex flexDirection="column" px="24px">
            {selectedVideos.map((video, index) => (
              <Box key={video.id} display={activeIndex === index ? 'block' : 'none'}>
                <Field mb="16px" width="100%" name={`buttonTexts.${video.id}`} label="Button Text" dark component={FormInput} />
                <Field
                  mb="16px"
                  width="100%"
                  name={`buttonLinks.${video.id}`}
                  label="Button Link"
                  placeholder="https://..."
                  dark
                  component={FormInput}
                />
              </Box>
            ))}
          </Flex>
        )
      case MODAL_OPEN_TYPES.NAVIGATION:
        return (
          <Flex flexDirection="column" px="24px">
            {selectedVideos.map((video, index) => (
              <Box key={video.id} display={activeIndex === index ? 'block' : 'none'}>
                <Field
                  mb="16px"
                  width="100%"
                  name={`buttonLinks.${video.id}`}
                  label="Link"
                  placeholder="https://..."
                  dark
                  component={FormInput}
                />
              </Box>
            ))}
          </Flex>
        )
      default:
        return null
    }
  }

  return (
    <ModalContainer noClose p="0px" width="800px" height="600px" isOpen={!!modalOpenType} setIsOpen={setModalOpenType}>
      <Flex height="68px" alignItems="center" px="24px" borderBottom="1px solid #EDF2F7">
        <Text fontSize="18px" fontWeight="600">
          Edit {modalOpenType.charAt(0) + modalOpenType.slice(1).toLowerCase()}
        </Text>
      </Flex>
      <Flex height="calc(100% - 68px)">
        <Flex
          flexDirection="column"
          width="333px"
          height="100%"
          position="relative"
          pt="40px"
          overflowY="auto"
          noScrollBar
          pb="40px"
        >
          <ImageCarousel videos={selectedVideos} activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
          {renderFields()}
        </Flex>

        <Box backgroundColor="#F7FAFC" width="467px" height="100%" overflowY="auto" noScrollBar>
          <ThumbnailGrid
            videos={selectedVideos}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
            getImageUrl={getImageUrl}
          />
        </Box>
      </Flex>
      <ModalContainer p="0px" width="90%" height="90%" isOpen={showVideoToProductModal} setIsOpen={setShowVideoToProductModal}>
        <VideoProductModal close={() => setShowVideoToProductModal(false)} video={activeVideo} refresh={() => {}} />
      </ModalContainer>
    </ModalContainer>
  )
}

export default TitleShoppingButtonModal
